import { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import axios from 'helpers/axios';
import { ToastContext } from 'contexts';
import { PROJECTS_SEARCH } from 'constants/apis';
import { SORT_BY, PROJECT_STATUS, PROJECT_SOURCE } from 'constants/opportunities';

export const useDashboardFollowedProjectsSearch = ({
  limit = 25,
  page = 1,
  search = '',
  sort = SORT_BY.mostRecent,
  direction = 'desc',
}) => {
  const { t } = useTranslation();
  const { triggerToast } = useContext(ToastContext);

  const body = useMemo(
    () => ({
      type: 'pinned',
      statuses: [PROJECT_STATUS.open, PROJECT_STATUS.closed],
      sources: [PROJECT_SOURCE.bonfire, PROJECT_SOURCE.external],
      projectTypes: [],
      locations: [],
      search,
    }),
    [search]
  );

  const queryParams = useMemo(
    () => ({
      params: {
        limit,
        page,
        sort,
        direction,
      },
    }),
    [limit, page, sort, direction]
  );

  const { data: { data, headers } = {} } = useQuery(
    ['projects', 'search', 'following', 'dashboard', { ...body, ...queryParams }],
    () => axios.post(PROJECTS_SEARCH, body, queryParams),
    {
      keepPreviousData: true,
      staleTime: 5000,
      onError: () => triggerToast({ message: t('generic_error') }),
    }
  );

  const totalCount = useMemo(() => parseInt(headers?.['x-total-count'] ?? 0, 10), [headers]);

  return { followedProjects: data ?? [], totalCount };
};
